<form [formGroup]="dataform" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title">Motivo del rechazo</div>
  </div>
  <div class="modal-body">

    <div class="row">
      <div class="col-md-12 mt-2">
        <textarea [readonly]="idOrder!=null" formControlName="reason" type="text" class="form-control"
          placeholder="Motivo"
          [ngClass]="{'is-invalid':dataform.get('reason').invalid && (!dataform.get('reason').pristine || submitted == 1) , 'is-valid':dataform.get('reason').valid && !dataform.get('reason').pristine}"
          rows="2"></textarea>
        <div [hidden]="!dataform.controls['reason'].errors" class="invalid-feedback" style="top:auto !important">
          Motivo requerido
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="closeModal()">Cancelar</button>
    <button *ngIf="idOrder==null" class="btn btn-primary" type="submit">Guardar</button>
  </div>
</form>